import { Select } from 'antd'
import { useContext, useEffect, useRef, useState } from 'react'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import api from '../../services/api'

export function SL_CountrySelector({isLogin = false}) {
    const {selectedLanguage, handleSetSelectedLanguage, enums, user, setShowLoading} = useContext(GeneralContext)
    const [countryListOptions, setCountryListOptions]=useState([])

    useEffect(()=>{
        if (enums?.ECountries){defineOptions()}
    },[enums])

    useEffect(()=>{
        const storedLanguageCode = localStorage.getItem("language")
        if (!selectedLanguage && storedLanguageCode) {
            handleSetSelectedLanguage(storedLanguageCode)
        }
    },[])

    const defineOptions =(code = null)=>{
        
        const selectOptions = Object.values(enums.ECountries).map(e=> ({
            label: e?.description[(code? 
                code - 1 : 
                Number.isInteger(parseInt(selectedLanguage)) ? 
                    (parseInt(selectedLanguage) - 1) : 0
        )], 
            value: e?.code
        }))
        setCountryListOptions(selectOptions)
    }

    const changeLanguage = async(code)=>{
        setShowLoading(true)
        try {
            
            if (user) {
                localStorage.setItem("language", code)
                handleSetSelectedLanguage(code)
                let token = localStorage.getItem("token") ?? null
                
                await api.user.updateLanguage({
                    ...user,
                    lenguage_code: code,
                    token
                })
            }
            localStorage.setItem("language", code)
            handleSetSelectedLanguage(code)
            if(!isLogin){
                window.location.reload()
            }
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
            defineOptions(code)
        }
    }

    // popualate the countryList with
    return (
        <Select 
        className='min-w-[100px]'
            options={countryListOptions}
            onChange={(e)=>changeLanguage(e)}
            value={parseInt(selectedLanguage)}
        />
    )
}
